import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, AlertController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';

import { QnaPage } from '../qna/qna';
import { LoginPage } from '../login/login';
import { QnaformPage } from '../qnaform/qnaform';

/**
 * Generated class for the QnalistPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
	selector: 'page-qnalist',
	templateUrl: 'qnalist.html',
})
export class QnalistPage {

	list: any[];
    items: any[] = [];
    count_list: number = 0;
    max_list: number = 0;
	

	loginId: string;
	api_key: string;
	version: string;
	noti_title: string;
	noti_date: string;

	texts: any = [];
	language: string;

	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		public modalCtrl: ModalController,
		public alertCtrl: AlertController,
        private http: HttpService,
		public app: App
	) {
		
	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		this.loginId = localStorage.getItem("loginId");
        if(!this.api_key) {
            this.app.getRootNav().setRoot(LoginPage);
        }

        //// 페이지 이름
        localStorage.setItem("pageName", "qnalist");
		this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");

		this._init();
		
		this._get_texts();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).qnalist;
	}

	_init() {
		this.list = [];
		
		let url = "info/qa/index/list";
		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
				if(res.list == undefined) {
					return;
				}else {
					this.list = res.list;
					this.max_list = res.list.length;
					this.items = [];
					this.count_list = 0;
					for (var i = 0; i < 9; i++) {
						if(this.max_list <= this.count_list) break;
						this.items.push(this.list[this.count_list]);
						this.count_list ++;
					}
				}
			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                this.navCtrl.pop();
			}
		
		},(err)=>{
			let alert = this.alertCtrl.create({
				message: err,
				buttons: ['OK']
			});
			alert.present();
		});
	}

	_items_inf(infiniteScroll) {
        setTimeout(() => {    
            for (var i = 0; i < 9; i++) {
                if(this.max_list <= this.count_list) break;
                this.items.push(this.list[this.count_list]);                
                this.count_list ++;
            } 

            infiniteScroll.complete();
        }, 500);
    }

	_open_qna_modal(item: any) {
		this.navCtrl.push(QnaPage, {idx: item});
	}

	_question() {
		this.navCtrl.push(QnaformPage);
	}
}



// WEBPACK FOOTER //
// ./src/pages/qnalist/qnalist.ts